import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "../../../utils/Utils";
import store from '../../../store';


class GetBookmark extends AbstractRequestTask {

  constructor(group_id = '', version='v1') {
    super();
    this._group_id = group_id;
    this.version = version;

  }

  getHeaders() {
    return {};
  }

    getUrl() {

      const protocol = 'https';
      const server = Launcher.get("akamai_mfwk");
      const endpoint = 'services/user';
      const version = this.version;
      const apiname = 'getbookmark';
      
      return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
    }

  getParams() {
    const params = super.getParams();
    const group_id = this._group_id;
    const user = store.getState().user;
    const lasttouch = user && user.lasttouch ? user.lasttouch.seen : false;

    if (lasttouch) {
      params.lasttouch = lasttouch;
    }
    // Solo en esta api es filter_list y no  filterlist como en las demas
    //https://dlatvarg.atlassian.net/wiki/spaces/GCV/pages/267059977/user+getbookmark?focusedCommentId=621510829#comment-621510829
    const filter_list = Utils.getAPAFilterList();
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { group_id, filter_list });
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default GetBookmark;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/GetBookmarkTask.js